module.exports = __webpack_public_path__ + "static/img/13.9739d66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/13.png
// module id = P/7a
// module chunks = 0